import Button from './Button'
import { useRunAlgorithm } from '../hooks/algoritmi-functions'
import { useGetBackendRQuery } from '../hooks/api-slice'

const ButtonRun = ({ buttonText, algorithm }) => {
  const { data: backendR } = useGetBackendRQuery()

  const { runAlgorithm } = useRunAlgorithm()

  const lastTime = backendR?.[`${algorithm}-lastTime`]

  return (
    <center>
      <Button onClick={() => runAlgorithm({ algorithm })}>{buttonText}</Button>
      <p style={{ fontSize: 16 }}>Ultima esecuzione:&nbsp;{lastTime || '?'}</p>
    </center>
  )
}

export default ButtonRun
